import React from "react";

const Header = () => {
  return (
    <React.Fragment>
      <div className="login-header">
        <div className="login-header-inner">
          <a className="login-header-logo" href="/login" aria-label="IPCS workbench portal home">
            <img alt="IPCS" src="/assets/Img/logo.png" />
          </a>
        </div>
      </div>

      <div className="login-welcome">
        <div className="login-welcome-content">
          <div className="login-welcome-brand">
            <span>Human Resources Information Management System (HRIMS)</span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;
